import { AlertTriangle } from "lucide-react";
import { Button } from "./ui/button";
import { navigate } from "../lib/router";

interface RenewalBannerProps {
    status?: string;
    planType?: string;
}

export function RenewalBanner({ status, planType }: RenewalBannerProps) {
    if (!status || !planType || planType === 'free') return null;

    if (status === 'past_due' || status === 'incomplete') {
        return (
            <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-xl flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 animate-in fade-in slide-in-from-top-4">
                <div className="flex items-start gap-3">
                    <AlertTriangle className="h-5 w-5 text-amber-600 mt-0.5 sm:mt-0" />
                    <div>
                        <p className="font-semibold text-amber-900">
                            Problema na renovação da assinatura
                        </p>
                        <p className="text-sm text-amber-700 mt-1">
                            Não conseguimos processar o pagamento do seu plano {planType}. Atualize seus dados para evitar o bloqueio.
                        </p>
                    </div>
                </div>
                <Button
                    className="bg-amber-100 text-amber-900 hover:bg-amber-200 border-0 whitespace-nowrap w-full sm:w-auto"
                    onClick={() => navigate("/")}
                >
                    Resolver agora
                </Button>
            </div>
        );
    }

    if (status === 'canceled' || status === 'inactive' || status === 'unpaid') {
        return (
            <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-r-xl flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 animate-in fade-in slide-in-from-top-4">
                <div className="flex items-start gap-3">
                    <AlertTriangle className="h-5 w-5 text-red-600 mt-0.5 sm:mt-0" />
                    <div>
                        <p className="font-semibold text-red-900">
                            Sua assinatura expirou
                        </p>
                        <p className="text-sm text-red-700 mt-1">
                            Renove seu plano {planType} para recuperar o acesso a todos os recursos exclusivos.
                        </p>
                    </div>
                </div>
                <Button
                    className="bg-red-100 text-red-900 hover:bg-red-200 border-0 whitespace-nowrap w-full sm:w-auto"
                    onClick={() => navigate("/")}
                >
                    Renovar agora
                </Button>
            </div>
        );
    }

    return null;
}
